import React from 'react';

import { pipe } from '@code-expert/prelude';
import { parser, succeed } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import { TopNavLayout } from '/imports/ui/layouts/TopNavLayout';
import { InvalidEnrolmentLink } from './InvalidEnrolmentLink';
import { enrollBaseRoute, enrollSubRoute } from './routes';

const Enroll = React.lazy(() => import('./Enroll'));

const InvalidEnrollmentLinkRoute = () => (
  <Authorise
    deny={['exam', 'lti']}
    layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
  >
    <InvalidEnrolmentLink />
  </Authorise>
);

export const enrollRouter = pipe(
  // Match /enroll
  enrollBaseRoute.parser,
  parser.chain((_) =>
    pipe(
      // Match /{semester}/{courseUrl}
      enrollSubRoute.parser,
      parser.map((props) => (
        <Authorise
          deny={['exam', 'lti']}
          layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
        >
          <Enroll {...props} />
        </Authorise>
      )),
      // Fall back to error message
      parser.alt(succeed(<InvalidEnrollmentLinkRoute />).parser),
    ),
  ),
);
